// extracted by mini-css-extract-plugin
export default {"content":"HeaderContent_content__LadJa"};